import React, { Component } from 'react';
import { Grid, Segment, Divider } from 'semantic-ui-react'

export default class NotFound extends Component {

    render() {

        setTimeout(
            function() {
                this.props.history.push("./overview");
            }
            .bind(this),
            10000
        );

        return (
            <div>
                <renderContainer />
                <Divider hidden />
                <Grid stackable>
                    <Grid.Column>
                        <Segment>
                            <div><b>404 - Page Not Found</b></div>
                            <div>&nbsp;</div>
                            <Divider fitted />
                            <Divider hidden />
                            You can click back to try again or continue to the <a href="/overview" rel="noreferrer noopener">Overview</a> page.
                            <Divider hidden />
                        </Segment>
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/NotFound/index.js